module.exports = "form {\n  display: flex;\n  flex-direction: column; }\n  form * {\n    width: 100%; }\n"